import ShellMaterial from "../../rendering/star/shell-material";

class Shell extends THREE.Mesh {
    constructor({ star, temperature, map, normalMap }) {
        const geometry = new THREE.SphereBufferGeometry(7.5, 128, 128);
        const material = new ShellMaterial({ temperature, map, normalMap });

        super(geometry, material);

        this.type = "Shell";
        this.overridePicker = star;
    }

    update(time) { this.material.uniforms.time.value = time; }
}

export default Shell;
export { Shell };